import AlertBox from "components/partials/alert-box/alert-box";
import { TouchpointBuilderTabForm } from "containers/admin/clients/touchpoint/components/email-builder/email-builder";

import { useClaimVersionLock } from "hooks/api/use-touchpoint-versions";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";
import { useCurrentTouchpoint } from "hooks/api/use-current-touchpoint";

const EmptyDesignPreview = ({
  redirectTo,
  currentVersion,
}: {
  redirectTo: string;
  currentVersion?: { id: string };
}) => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const currentTouchpoint = useCurrentTouchpoint();
  const claimLockMutation = useClaimVersionLock({
    clientId: currentClient.id,
    campaignId: currentCampaign.id,
    touchpointId: currentTouchpoint.id,
  });
  return (
    <TouchpointBuilderTabForm>
      <AlertBox
        sx={{ mt: 4, maxWidth: "42rem", mx: "auto" }}
        alert={{
          status: "info",
          title: "Ready for Content",
          button: {
            path: redirectTo,
            label: "Get Started",
            variant: "secondary",
            onClick: () => {
              claimLockMutation.mutate(currentVersion?.id as string);
            },
          },
        }}
        showCloseButton={false}
      />
    </TouchpointBuilderTabForm>
  );
};

export default EmptyDesignPreview;
